module.exports = __webpack_public_path__ + "img/UTGREE.87228ffc.png";